// extracted by mini-css-extract-plugin
module.exports = {"container":"layout-module--container--2efNX","content":"layout-module--content--3nxb4"};